module.exports = __webpack_public_path__ + "static/img/Adam-Treloar.51c97c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Adam-Treloar.jpg
// module id = c1fO
// module chunks = 0